"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWithHook = wrapWithHook;
function wrapWithHook(callback, hook) {
  if (hook) {
    return hook(callback);
  }
  return callback();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ3cmFwV2l0aEhvb2siLCJjYWxsYmFjayIsImhvb2siXSwic291cmNlcyI6WyIuLi8uLi9zcmMvbGliL3dyYXAtd2l0aC1ob29rLnRzIl0sInNvdXJjZXNDb250ZW50IjpbInR5cGUgV3JhcFdpdGhIb29rQ2FsbGJhY2s8VD4gPSAoKSA9PiBUO1xuZXhwb3J0IHR5cGUgV3JhcEhvb2s8VD4gPSAoY2FsbGJhY2s6IFdyYXBXaXRoSG9va0NhbGxiYWNrPFQ+KSA9PiBUO1xuXG5leHBvcnQgZnVuY3Rpb24gd3JhcFdpdGhIb29rPFQ+KFxuICBjYWxsYmFjazogV3JhcFdpdGhIb29rQ2FsbGJhY2s8VD4sXG4gIGhvb2s6IFdyYXBIb29rPFQ+IHwgbnVsbCB8IHVuZGVmaW5lZFxuKTogVCB7XG4gIGlmIChob29rKSB7XG4gICAgcmV0dXJuIGhvb2soY2FsbGJhY2spO1xuICB9XG5cbiAgcmV0dXJuIGNhbGxiYWNrKCk7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUdPLFNBQVNBLFlBQVksQ0FDMUJDLFFBQWlDLEVBQ2pDQyxJQUFvQyxFQUNqQztFQUNILElBQUlBLElBQUksRUFBRTtJQUNSLE9BQU9BLElBQUksQ0FBQ0QsUUFBUSxDQUFDO0VBQ3ZCO0VBRUEsT0FBT0EsUUFBUSxFQUFFO0FBQ25CIn0=